export const stateSetting = {
	setting: {
		param:null,
	},
};

export const mutSetting = {
	setting_set_param(state,param){
		state.setting.param= param;

		console.log("setting_set_param : ");
		console.log(param);
	},
}

export const getSetting={
	get_setting_param : (state) =>{ return state.setting.param; },
	get_user_id : (state) => {
		if(state.setting.param &&
			state.setting.param.user)
		{
		 	return state.setting.param.user.user_id;
		}
		return null;
	},
	get_user_name : (state) => {
		if(state.setting.param &&
			state.setting.param.user)
		{
		 	return state.setting.param.user.user_name;
		}
		return null;
	},
	get_csrf_token : (state) => {
		if(state.setting.param )
		{
		 	return state.setting.param.csrf_token;
		}
		return null;
	},
	get_check_client : (state) => {
		if(state.setting.param )
		{
			if (state.setting.param.is_client == 1) {
				return false;
			}
			return true;
		}
		return null;
	},
}



// WEBPACK FOOTER //
// ./resources/assets/js/state/Setting.vuex.js